import React, { Component } from 'react';
import { domainUrl, rootDomainUrl } from '../config/Config';
import { reactLoader, getTokenData, contentResizeLoad, showSmallLeftMenu } from '../helpers/Common';
import { handleCheckbox, handleRadio, handleSequence } from '../helpers/Fields';
import Flowplayer from '../components/Flowplayer';
import TestGraph from '../components/TestGraph';
import Imagezoom from '../components/Imagezoom';
import Confidencemeter from '../components/Confidencemeter';
const $ = window.$;
const win=window;


export default class Testresults extends Component {
	constructor(props) {
		super(props);
		this.state = {
			flowresult: false,
			componentStatus: this.props.data.status,
			observerEvaluation: false,
			evaluationPanel: false,
			testquestions: [],
			testcont: [],
			statusMessage: "",
			chart_graph: "",
			quscomd: [],
			videoTracks: [],
			actualToScore: "",
			percentage: "",
			winningAmount: "",
			losingAmount: "",
			performanceAmount: "",
			betStatus: "",
			isCompletedFully: false,
			isrepeatcomp:'N',
			mcq_type:"",
			anskeyshow:false,
			
		};
	}
	getTestdetails(data) {
		reactLoader("show", "Please wait...");
		fetch(domainUrl + 'normal-test/getresults', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({ data })
		}).then((response) => response.json()).then((responseJson) => {
			this.setState({
				corporate_id: responseJson.corporate_id,
				testcont: responseJson.Mcq_details,
				testquestions: responseJson.McqQuestions,
				quscomd: responseJson.QuestionCom,
				chart_graph: (responseJson.Mcq_details.showgraph > 0) ? <TestGraph scoredet={responseJson.Mcq_details} /> : '',
				isrepeatcomp:responseJson.isrepeatcomp,
				percentage: responseJson.Mcq_details.score_percentage,
				mcq_type:responseJson.Mcq_details.mcq_type
			});
			if (responseJson.Mcq_details.is_betcomponent > 0) {
				this.setState({
					actualToScore: responseJson.bet_details.actualToScore,
					percentage: responseJson.bet_details.percentage,
					winningAmount: responseJson.bet_details.winningAmount,
					losingAmount: responseJson.bet_details.losingAmount,
					performanceAmount: responseJson.bet_details.performanceAmount,
					betStatus: responseJson.bet_details.betStatus,
					videoTracks: responseJson.bet_details.videoTracks,
					isCompletedFully: responseJson.isCompletedFully,
					
				});
				
			}
			setTimeout(() => {
				contentResizeLoad();
				showSmallLeftMenu();
				contentResizeLoad();
				reactLoader("hide");
			}, 200);
			if(this.state.testcont.imagezoom)
			{
				$(function() {
					$('[data-chittizoom]').chittizoom();
				});
			}

		});
	}
	componentDidMount() {
		
		const { data } = this.props;
		if (data.flowresult) {
			this.setState({ flowresult: true });
		}
		this.getTestdetails(data);
		setTimeout(() => {
			$('audio').on("play", function (me) {
				$('audio').each(function (i, e) {
					if (e !== me.currentTarget) {
						this.pause();
					}
				});
			});
			
		}, 500)
		
	}
	componentWillReceiveProps(nextProps) {
		const { data } = nextProps;
		this.getTestdetails(data);
	}
	backToComponentList() {
		const { data } = this.props;
		if (this.state.isCompletedFully) {
			this.props.returnthanks({
				"status": "completed",
				"learning_room_id": data.learning_room_id,
				"compseq_id": data.compseq_id,
				"divider_id": data.divider_id,
				"dlr_id": data.dlr_id,
				"learner_id": data.learner_id,
				"is_ag": data.is_ag,
				"id": data.id,
				"compo_type": "thanks",
				"look_before": data.compseq_id,
				"flowresult": true
			});
		} else {
			this.props.switchback('component_list', data.learning_room_id, data.dlr_id);
		}
	}
	showhidevideo()
	{
		if($("#showhidevideobtn").val()==="Show video")
		{
			$("#showhidevideobtn").val('Hide video');
			$("#showhideplayer").toggle();
		}		
		else
		{
			// stop playing video 
			let flowplayerelement=$(".flowplayer");
			let flowplapi=win.flowplayer(flowplayerelement);
			flowplapi.stop(flowplayerelement);
			$("#showhidevideobtn").val('Show video');
			$("#showhideplayer").toggle();
			$("html, body").animate({ scrollTop: 0 }, "slow");
		}
	
		
	}

	continueToComplete() {
		this.setState({ flowresult: false });
	}
	getoptions(ans_opt,imagezoomopt) {
		let op_val = '';
		switch (ans_opt.options) {
			case 'image':
				op_val = (imagezoomopt) ? <Imagezoom izsrc={rootDomainUrl + "admin/test_image_files/" + ans_opt.add_on_answer_image} izalt="" izwidth="150" izheight="150" />:<img src={rootDomainUrl + "admin/test_image_files/" + ans_opt.add_on_answer_image} alt="" width="150" height="150" />
				break;
			case 'audio':
				op_val = <audio controls controlsList="nodownload">
					<source src={rootDomainUrl + "admin/test_audio_files/" + ans_opt.add_on_answer_audio} type="audio/mpeg" />
				</audio>
				break;
			case 'video':
				op_val = this.video_frame(ans_opt.add_on_answer_video, '');
				break;
			default:
				op_val = <div dangerouslySetInnerHTML={{ __html: ans_opt.options }}></div>
				break;
		}
		return op_val;
	}
	submitbuttons() {
		return <div id="InActive" className="button">
			<input value="Submit" className="button_org_inactive" type="button" onClick={(e) => this.submittest()} />
		</div>
	}
	getquestion(quest_det, ans_opt, i,imagezoomopt) {
		let qty_val = [];
		let questionaire_id = quest_det.questionaire_id;
		let showanswer = quest_det.showanswer;
		let question_type = quest_det.question_type;
		let rs_img = (ans_opt.score > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif';
		switch (question_type) {
			case 1:
				qty_val = <li key={`list_${i}`} className="qleft">
					{(showanswer == "1") ?
						<span className="flefts"><img src={rs_img} alt="" border="0" /></span> :
						<span></span>
					}
					<span className="flefts"><input type='radio' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered) >= 0} name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>
				break;
			case 2:
				qty_val = <li key={`list_${i}`} className="qleft"><span className="flefts">{i}. </span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 3:
				qty_val = <li key={`list_${i}`} className="qleft">
					<span className="flefts"><img src={rs_img} alt="" border="0" /></span>
					<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered) >= 0} type='checkbox' name={quest_det.question_id} onClick={(e) => handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 4:
				qty_val = <li key={`list_${i}`} className="qleft testopt">
					<span className="sfleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 5:
				qty_val = <li key={`list_${i}`} className="qleft">
					<span className="flefts"><img src={rs_img} alt="" border="0" /></span>
					<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, quest_det.answered) >= 0} type='radio' name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 9:
					qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
					<span className="flefts">{i}</span>
					<span style={{marginRight: '0.5em'}}>{ans_opt.options}</span>
					<input type="text"  name={quest_det.question_id}/>
					</li>;
				break;
			case 10:
					qty_val=<li key={`list_${quest_det.question_id}`} className="qleft">
					<span className="flefts">{i}</span>
					<span style={{marginRight: '0.5em'}}><span>{ans_opt.options}</span></span>
					<span style={{marginRight: '1.5em'}}><input style={{float:'right',marginRight:'480px'}} type="radio" name={quest_det.question_id +'_most'}  /></span>
					<input  style={{float:'right',marginRight:'-87px'}} type="radio" name={quest_det.question_id +'_least'} />
					</li>;

				break;
			default:
				qty_val = '';
				break;
		}
		return qty_val;
	}


	getquestion_anskey(quest_det, ans_opt, i,imagezoomopt) {
		let qty_val = [];
		let question_type = quest_det.question_type;
		let rs_img = (ans_opt.score > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : '';
		let getcorrecans=quest_det.correct_answer.split(",");
		switch (question_type) {
			case 1:
				qty_val = <li key={`list_${i}`} className="qleft">
					<span className="flefts">{rs_img!='' && <img src={rs_img} alt="" border="0" />}</span>
					<span className="flefts"><input type='radio' defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, getcorrecans) >= 0} name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>
				break;
			case 2:
				qty_val = <li key={`list_${i}`} className="qleft"><span className="flefts">{i}. </span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 3:
				qty_val = <li key={`list_${i}`} className="qleft">
					<span className="flefts">{rs_img!='' && <img src={rs_img} alt="" border="0" />}</span>
					<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, getcorrecans) >= 0} type='checkbox' name={quest_det.question_id} onClick={(e) => handleCheckbox(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 4:
				qty_val = <li key={`list_${i}`} className="qleft testopt">
					<span className="sfleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			case 5:
				qty_val = <li key={`list_${i}`} className="qleft">
					<span className="flefts">{rs_img!='' && <img src={rs_img} alt="" border="0" />}</span>
					<span className="flefts"><input defaultChecked={$.inArray(ans_opt.mcq_answer_id_pk, getcorrecans) >= 0} type='radio' name={quest_det.question_id} onClick={(e) => handleRadio(e)} value={ans_opt.mcq_answer_id_pk} disabled /></span>
					<span className="fleft">{this.getoptions(ans_opt,imagezoomopt)}</span>
				</li>;
				break;
			default:
				qty_val = '';
				break;
		}
		return qty_val;
	}
	matchfillfun(mk,imagezoomopt) {
		let sdf = <li className="qleft">
			<p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
			<div className="tab-match-container">
				<table className="tbl-match">
					<thead>
						<tr className="tbl-match-head">
							<td><b>SET A</b></td>
							<td><b>Correct match from Set B</b></td>
							<td><b>SET B</b></td>
						</tr>
					</thead>
					<tbody>
						{mk.mcq_match_filling.map((mc, r) => {
							return <tr key={`matches_tr_${r}`} className="tbl-match-body">
								<td>
									<div className="statement">
										{mc.match_ques_type == 1 && <center>{mc.match_ques_src}</center>}
										{mc.match_ques_type == 2 && <center>
											{(imagezoomopt) ? 
											<Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} izalt="" izwidth="200" izheight="200" />
											:
											<img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} alt="" width="200" height="200" />
											}
											</center>}
										{mc.match_ques_type == 3 && <audio controls controlsList="nodownload">
											<source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ques_src} type="audio/mpeg" />
										</audio>
										}
										{mc.match_ques_type == 4 &&
											this.video_frame(mc.match_ques_src, '')
										}
									</div>
								</td>
								<td>
									<input type="text" name={mk.question_id} className="txtbox matchtxt" style={{ width: "40px" }} title="Enter one digit numeric input" onBlur={(e) => handleSequence(e)} defaultValue={mk.answered[r]} readOnly />
									<img src={(mc.match_correct_ans_order == mk.answered[r]) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif'} alt="" border="0" />
								</td>
								<td>
									<div>
										<span style={{ float: "left" }}>{r + 1}. </span>
										<div className="statement">
											{mc.match_ans_type == 1 && <center>{mc.match_ans_src}</center>}
											{mc.match_ans_type == 2 && <center>
												{(imagezoomopt) ? 
												<Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} izalt="" izwidth="200" izheight="200" />
												:
												<img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} alt="" width="200" height="200" />
												}
												</center>}
											{mc.match_ans_type == 3 && <audio controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ans_src} type="audio/mpeg" /></audio>
											}
											{mc.match_ans_type == 4 &&
												this.video_frame(mc.match_ans_src, '')
											}
										</div>
									</div>
								</td>
							</tr>
						})}
					</tbody>
				</table>
			</div>
		</li>;
		return sdf;
	}

	matchfillfun_anskey(mk,imagezoomopt) {
		let sdf = <li className="qleft">
			<p>Match Set A with correct item in Set B<br />Key in the corresponding no. (1,2,3...) in the box provided</p>
			<div className="tab-match-container">
				<table className="tbl-match">
					<thead>
						<tr className="tbl-match-head">
							<td><b>SET A</b></td>
							<td><b>Correct match from Set B</b></td>
							<td><b>SET B</b></td>
						</tr>
					</thead>
					<tbody>
						{mk.mcq_match_filling.map((mc, r) => {
							//console.log(mc);
							return <tr key={`matches_tr_${r}`} className="tbl-match-body">
								<td>
									<div className="statement">
										{mc.match_ques_type == 1 && <center>{mc.match_ques_src}</center>}
										{mc.match_ques_type == 2 && <center>
											{(imagezoomopt) ? 
											<Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} izalt="" izwidth="200" izheight="200" />
											:
											<img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ques_src} alt="" width="200" height="200" />
											}
											</center>}
										{mc.match_ques_type == 3 && <audio controls controlsList="nodownload">
											<source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ques_src} type="audio/mpeg" />
										</audio>
										}
										{mc.match_ques_type == 4 &&
											this.video_frame(mc.match_ques_src, '')
										}
									</div>
								</td>
								<td>
									<input type="text" name={mk.question_id} className="txtbox matchtxt" style={{ width: "40px" }} title="Enter one digit numeric input" onBlur={(e) => handleSequence(e)} defaultValue={mc.match_correct_ans_order} readOnly />
									<img src={process.env.PUBLIC_URL + '/images/tick.gif'} alt="" border="0" />
								</td>
								<td>
									<div>
										<span style={{ float: "left" }}>{r + 1}. </span>
										<div className="statement">
											{mc.match_ans_type == 1 && <center>{mc.match_ans_src}</center>}
											{mc.match_ans_type == 2 && <center>
												{(imagezoomopt) ? 
												<Imagezoom izsrc={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} izalt="" izwidth="200" izheight="200" />
												:
												<img src={rootDomainUrl + '/admin/test_image_files/' + mc.match_ans_src} alt="" width="200" height="200" />
												}
												</center>}
											{mc.match_ans_type == 3 && <audio controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + mc.match_ans_src} type="audio/mpeg" /></audio>
											}
											{mc.match_ans_type == 4 &&
												this.video_frame(mc.match_ans_src, '')
											}
										</div>
									</div>
								</td>
							</tr>
						})}
					</tbody>
				</table>
			</div>
		</li>;
		return sdf;
	}
	video_frame(video_files, text = "") {
		const { data } = this.props;
		let trackData = {
			compseq_id: data.compseq_id,
			lroom_id: data.learning_room_id,
			divider_id: data.divider_id,
			learner_id: data.learner_id,
			dlr_id: data.dlr_id,
			compo_type: data.compo_type
		};
		let playlist = {
			share: false,
			ratio: 9 / 16,
			clip: {
				sources: [
					{
						type: "video/mp4",
						src: rootDomainUrl + 'admin/test_video_files/' + video_files
					}
				]
			}
		};
		return <Flowplayer key={Date.now()} playlist={playlist} trackData={trackData} />;
	}
	video_frameexp(video_files, text = "") {
		const { data } = this.props;
		let trackData = {
			compseq_id: data.compseq_id,
			lroom_id: data.learning_room_id,
			divider_id: data.divider_id,
			learner_id: data.learner_id,
			dlr_id: data.dlr_id,
			compo_type: data.compo_type
		};
		let playlist = {
			share: false,
			ratio: 9 / 16,
			clip: {
				sources: [
					{
						type: "video/mp4",
						src: rootDomainUrl + 'admin/test_video_exp_files/' + video_files
					}
				]
			}
		};
		return <Flowplayer key={Date.now()} playlist={playlist} trackData={trackData} />;
	}
	openendquestions(mk) {
		let disp = <li>
			<div className="statement">
				<div className="bluetxt">Your Answer:</div>
				<span className="textbox_align">{mk.answered}</span>
			</div>
		</li>;
		return disp;
	}

	repeatcomptakeretest()	{
		let getthisobj=this;
		const {data} = this.props;
		let mcqtype=this.state.mcq_type;
		if(mcqtype=="normaltest")
        data.compo_type="repeatnormaltest";
        else if(mcqtype=="testonebyone" || mcqtype=="testgoback")
		data.compo_type="repeattestonebyone";
		else if(mcqtype=="fixedtimetest")
		data.compo_type="repeatfixedtimetest";
		else if(mcqtype=="timevariabletest")
		data.compo_type="repeattimevariabletest";

		window.swal({
			//title: 'View!',
			text: 'You can repeat this test but your score will not change.',
		   // type: 'question',
			showCancelButton: true,
			confirmButtonColor: '#14a430',
			cancelButtonColor: '#0082c9',
			animation: false,
			confirmButtonText: 'Ok'
		}).then((result) => {
			
			if (result) {
				this.props.switchrepeatretest(data);
			}
			
		}, function(dismiss){
			if(dismiss == 'cancel'){
				getthisobj.setState({anskeyshow:true});
				$(function() {
					$('[data-chittizoom]').chittizoom();
				});
			}}
			);
		
		
	}


	showanswerkey(){
		window.swal({
			//title: 'View!',
			text: 'You cannot repeat this test after viewing the answer key.',
		   // type: 'question',
			showCancelButton: true,
			confirmButtonColor: '#14a430',
			cancelButtonColor: '#0082c9',
			animation: false,
			confirmButtonText: 'Ok'
		}).then((result) => {
			if (result) {
				this.setState({anskeyshow:true});
				$(function() {
					$('[data-chittizoom]').chittizoom();
				});
			}
		});
	}

	openendquestions_anskey(mk) {
		let disp = <li>
			<div className="statement">
				<div className="bluetxt">Correct Answer:</div>
				<span className="textbox_align"><span className="nostlyespan" > YTA<sup>*</sup></span></span>
			</div>
		</li>;
		return disp;
	}

	render() {
		let data = this.state.testcont;
		let quscomd = this.state.quscomd;
		let isrepeatcomp = this.state.isrepeatcomp;
		let optionText = [];
		let Propdata = this.props.data;
		let trackData = {
			compseq_id: Propdata.compseq_id,
			lroom_id: Propdata.learning_room_id,
			divider_id: Propdata.divider_id,
			learner_id: Propdata.learner_id,
			dlr_id: Propdata.dlr_id,
			compo_type: data.compo_type
		};
		
		return (<div className="main-inner">
			<div className="border-box">
				<div className={data.base_line ? "title-box" : "title-box tit-new"}>

					<div title="Videocomponents" className="ts_active_button"></div>
					<h6>{data.mcq_name ? data.mcq_name : ''}</h6>
					<span>{data.base_line ? data.base_line : ''}</span>
				</div>
				{/* {data.learner_msg && data.learner_msg !== "" &&
					<div style={{ float: "left", padding: "10px 0px 10px 0px", marginLeft: "25px" }}><div className="editortxt">
						<span dangerouslySetInnerHTML={{ __html: data.learner_msg ? data.learner_msg : '' }} />
					</div></div>
				} */}
				<section className="scrol" id="smana-scroll-inner">
					<section className="viewport">
						<section className="overview">
							<div className="inner-content">

								{this.state.flowresult && <div className="test-result">
									<div className="success-msg">Successfully completed the Session.</div>

									{ data.score_disable == false && data.is_performance && <div className="lr-yellow-box"> You have scored <span> {(this.state.percentage!='') ? this.state.percentage+'%' : ''} ({((data.actual_score != undefined) ? data.actual_score : '') + '/' + ((data.out_of_score != undefined) ? data.out_of_score : '')})</span> { data.show_yta==1 && <span className="nostlyespan" >, YTA<sup>*</sup>.</span> }&nbsp;&nbsp;
									{isrepeatcomp=='N' && <div>
				                  	<a href="javascript:void(0)" className="orange" onClick={() => this.continueToComplete()} >Click here</a> to view correct answers.
									</div>}
				                	</div>}

				                	{ data.score_disable == false && !data.is_performance && isrepeatcomp=='N' && <div className="lr-yellow-box"> <a href="javascript:void(0)" className="orange" onClick={() => this.continueToComplete()} >Click here</a> to view correct answers.</div> }
								

									{data.score_disable == false && data.score_comment != undefined && data.is_performance=='1' && <div className="testperformance">{data.score_comment}</div>}
									{data.is_betcomponent > 0 &&
										<div className="test_result">
											<table className="bet_table">
												<tbody>
													<tr className="challenge">
														<td> Your Challenge was to score <span className="set_challenge">{this.state.actualToScore}</span></td>
													</tr>
													<tr className="challenge_score">
														<td>Your Performance Score is <span className="lrpercentage">{this.state.percentage}%</span> in the Challenge</td>
													</tr>

													{this.state.betStatus === "lost" && <tr className="challenge_money">
														<td>You have Lost <span className="lost">{this.state.losingAmount}</span> Points in the Challenge</td>
													</tr>}

													{this.state.betStatus === "won" && <tr className="challenge_money">
														<td>You have Won <span className="won">{this.state.winningAmount}</span> Points in the Challenge</td>
													</tr>}

													<tr className="challenge_status">
														<td>You have got <span className="perfamnt">{this.state.performanceAmount}</span> Points for your Performance</td>
													</tr>
												</tbody>
											</table>
										</div>
									}

									{data.show_yta == '1' && <div className="grey-lite">
										<span className="bluetxt"><sup>*</sup>Few open ended questions and Audio Answers are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment</span>
									</div>}
									
									{(this.props.usableType == "webapp") ? <div className="button">
									<input type="submit" value="Continue" title="Continue" className="button_org" onClick={() => this.backToComponentList()} />
									&nbsp;&nbsp;
									{data.is_betcomponent > 0 && data.bet_type==1 && 
									<input type="button" value="Show video" title="Show video" id="showhidevideobtn"  style={{ display: 'block' }} className="button_org" onClick={() => this.showhidevideo()} />
									}
									{/* {data.is_betcomponent==0 && isrepeatcomp=='Y' &&
									<input type="button" value="Take retest" title="Take retest"   className="button_org" onClick={() => this.repeatcomptakeretest()} />
									} */}
									</div> : ""}
								</div>}

								{/* {this.state.videoTracks.playlist != undefined && */}
								{this.state.videoTracks.length!=0 &&
									<div id="showhideplayer" className="lr-gray-box videogray " style={{ display: 'none' }}>
										<Flowplayer key={Date.now()} playlist={this.state.videoTracks} trackData={trackData} />
									</div>
								}
								{isrepeatcomp=='Y' &&  this.state.anskeyshow==false && this.state.flowresult==false && 
								<div>  <div className="editortxtbx">
								<span><b>Message:</b>  Your final score for this test is <span> {(this.state.percentage!='') ? this.state.percentage+'%' : ''} ({((data.actual_score != undefined) ? data.actual_score : '') + '/' + ((data.out_of_score != undefined) ? data.out_of_score : '')})</span> { data.show_yta==1 && <span className="nostlyespan" >, YTA<sup>*</sup>.</span> } .  You can repeat this test if you want to, until you choose to view the answer key.</span> 
								</div>
								
								<div className="button">
								
								<br/>
								<br/>
								<input type="submit" value="Continue" title="Continue" className="button_org" onClick={() => this.backToComponentList()}  style={{ float: 'right' }} />&nbsp;&nbsp;	<input type="button" value="Answer Key" title="Answer Key"  className="button_org" onClick={() => this.showanswerkey()}  style={{ float: 'right' }}  />&nbsp;&nbsp;
								<input type="button" value="Repeat" title="Repeat"  className="button_org" onClick={() => this.repeatcomptakeretest()}  style={{ float: 'right' }} />
									</div> 
								
								</div>
								}

								{isrepeatcomp=='Y' && this.state.anskeyshow==true && this.state.flowresult==false &&   this.state.testquestions.map((mk, index) => {
										return <div key={`a${index}`} className="lr-gray-box test">
											<div className="graybox_border">
												<div className="margbtm para">
													<span className="blwetxt bluetxt" style={{ float: "left" }}>Q{index + 1}.</span>
													<span className="quetn" dangerouslySetInnerHTML={{ __html: mk.mcq_question_name }} />
													{ mk.question_type == 10 && <span style={{paddingLeft:'441px'}}><b><span>Most</span><span style={{marginLeft:'32px'}}>Least</span></b></span>  }
													{mk.question_images.map((val, index) => {
														if (val != '' && val != undefined) {
															return <div key={`imageq${index}`} className="qleft">
															{(data.imagezoom)?
															<Imagezoom izkey={`img_${index}`} izsrc={rootDomainUrl + "admin/test_image_files/" + val} izalt="" izwidth={(mk.img_width)? mk.img_width : '400' }  />
															:
															<img key={`img_${index}`} src={rootDomainUrl + "admin/test_image_files/" + val} alt="" width={(mk.img_width)? mk.img_width : '400' }  />
															}
															</div>
														}
													})}
													{mk.question_audio.map((aval, aindex) => {
														if (aval != '' && aval != undefined) {
															return <div key={`auq${aindex}`} className="qleft"><audio key={`audio_${aindex}`} controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + aval} type="audio/mpeg" /></audio></div>
														}
													})}

													{mk.question_video.map((vval, vindex) => {
														if (vval != '' && vval != undefined) {
															return this.video_frame(vval, '');
														}
													})}

													<div className="test-ques">
														<div className="ans-select">
															<ul key={`aopt${index}`}>

																{/* {(mk.question_type == 2) && <li>Your Answer - <span>{mk.answered} <img src={(mk.is_correct_ans > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif'} alt="" /></span></li>} */}
																{(mk.question_type == 2) && <li>Correct Answer - <span>{mk.correct_answer}</span></li>}

																{mk.question_type == 4 && <span className=""><b>Your options are: </b></span>}
																{mk.question_option_answers.map((qas, i) => {
																	if (mk.question_type == 4) {
																		optionText.push(qas.options);
																	}
																	return this.getquestion_anskey(mk, qas, i + 1,data.imagezoom);
																})}

																{(mk.question_type == 6) && this.openendquestions_anskey(mk)}
																{(mk.question_type == 7) && this.matchfillfun_anskey(mk,data.imagezoom)}
															</ul>
															{mk.question_type == 8 && <div className="audiorecord">
															<li><div className="statement">
																<div className="bluetxt">Correct Answer:</div>
																<span className="textbox_align"><span className="nostlyespan" > YTA<sup>*</sup></span></span>
															</div></li>
															</div>}

															{mk.question_type == 4 && <span className="integratestsmalltxt">
																{/* Your Answer : {mk.answered} <img src={(mk.score > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif'} alt="" border="0" /><br />  */}
																Correct Answer : {mk.correct_answer}
															</span>
															}
														</div>
														<div className="dottedline"></div>
														{/* { data.is_performance && <div className="dottedline">
															<span className="bluetxt score">
																Your Score - <span className="greentxt"><strong>{(mk.is_YTA > 0 && mk.score < 1) ? <span className="greentxt">YTA<sup>*</sup></span> : mk.score}</strong>
																	{mk.is_hint_viewed > 0 && <strong>(You have viewed hint for this question)</strong>} </span>
															</span>
														</div> } */}
													</div>
													{mk.is_answer_explained == '1' &&
														<div className="ans-explanation">
															<h3>Answer Explanation</h3>

															{quscomd[mk.question_id].videoexpfile != '' && this.video_frameexp(quscomd[mk.question_id].videoexpfile, '')}

															{quscomd[mk.question_id].audiofile != '' &&
																<audio key='comd' controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + quscomd[mk.question_id].audiofile} type="audio/mpeg" /></audio>
															}

															{quscomd[mk.question_id].imagefile != '' && <div className="ans-exp-img">
															{(data.imagezoom)?
															<Imagezoom  izsrc={rootDomainUrl + "/admin/test_image_files/" + quscomd[mk.question_id].imagefile} izalt="" izwidth="300" />
															:
															<img  src={rootDomainUrl + "/admin/test_image_files/" + quscomd[mk.question_id].imagefile} alt="" width="300" />	
															}
															</div>
															}
															{quscomd[mk.question_id].answer_comment != '' && <p dangerouslySetInnerHTML={{ __html: quscomd[mk.question_id].answer_comment }} />}
														</div>
													}
												</div>
												{this.state.testcont.confidence_meter==1 ? <Confidencemeter dynamic_confidence={mk.question_id} confidence_result={mk.confidence_result} correct_ans={mk.correct_answer} /> : ''}
											</div>
										</div>
									})
									
									}
								{isrepeatcomp=='Y' && this.state.anskeyshow==true && this.state.flowresult==false && 
									<div className="button">
									<input type="submit" value="Continue" title="Continue" className="button_org" onClick={() => this.backToComponentList()} />
									</div>
								}

								{!this.state.flowresult && isrepeatcomp=='N' && <div className="test-result">
								
										{/* {data.is_betcomponent==0 && isrepeatcomp=='Y' &&
										<center style={{ padding: '10px 0px' }} >You can repeat the test any number of times,your score in the first attempt will be retained as actual score. 
										<a className="bluetxt" onClick={() => this.repeatcomptakeretest()}> Try Again</a></center>
										} */}

									{ data.is_performance && <div className="testscoretop">	
									{data.is_betcomponent > 0 &&  data.bet_type==1 && 	<div style={{ float: 'right' }}>
											<input type="button" value="Show video" title="Show video" id="showhidevideobtn"  style={{ display: 'block' }} className="button_org" onClick={() => this.showhidevideo()} />
										</div>}
									
										<span className="test-score">
										Score:&nbsp;  
											<strong>{(this.state.percentage!='') ? this.state.percentage+'%' : ''} ({((data.actual_score != undefined) ? data.actual_score : '') + '/' + ((data.out_of_score != undefined) ? data.out_of_score : '')})
											{data.show_yta == '1' && <span>, </span>}
											{data.show_yta == '1' && <span className="greentxt"><strong>YTA<sup>*</sup></strong></span>}
											</strong>
										</span>
										
										{data.show_yta == '1' && <div className="grey-lite">
											<span className="greentxt" ><sup>*</sup>Few Open ended questions and Audio answer questions are yet to be assessed. The final score might change once your observer(s)/ecoach completes their assessment</span>
										</div>}
									</div> }

									{this.state.chart_graph}

									{data.min_taken != undefined && <div className="testtimeresult">
										<div>Time taken: {data.hrs_taken > 0 && data.hrs_taken + 'hrs : '} {data.min_taken} min : {data.sec_taken} sec</div>
									</div>
									}

									{this.state.testquestions.map((mk, index) => {
										return <div key={`a${index}`} className="lr-gray-box test">
											<div className="graybox_border">
												<div className="margbtm para">
													<span className="blwetxt bluetxt" style={{ float: "left" }}>Q{index + 1}.</span>
													<span className="quetn" dangerouslySetInnerHTML={{ __html: mk.mcq_question_name }} />
													{ mk.question_type == 10 && <span style={{paddingLeft:'441px'}}><b><span>Most</span><span style={{marginLeft:'32px'}}>Least</span></b></span>  }
													{mk.question_images.map((val, index) => {
														if (val != '' && val != undefined) {
															return <div key={`imageq${index}`} className="qleft">
															{(data.imagezoom)?
															<Imagezoom izkey={`img_${index}`} izsrc={rootDomainUrl + "admin/test_image_files/" + val} izalt="" izwidth={(mk.img_width)? mk.img_width : '400' }  />
															:
															<img key={`img_${index}`} src={rootDomainUrl + "admin/test_image_files/" + val} alt="" width={(mk.img_width)? mk.img_width : '400' }  />
															}
															</div>
														}
													})}
													{mk.question_audio.map((aval, aindex) => {
														if (aval != '' && aval != undefined) {
															return <div key={`auq${aindex}`} className="qleft"><audio key={`audio_${aindex}`} controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + aval} type="audio/mpeg" /></audio></div>
														}
													})}

													{mk.question_video.map((vval, vindex) => {
														if (vval != '' && vval != undefined) {
															return this.video_frame(vval, '');
														}
													})}

													<div className="test-ques">
														<div className="ans-select">
															<ul key={`aopt${index}`}>

																{(mk.question_type == 2) && <li>Your Answer - <span>{mk.answered} <img src={(mk.is_correct_ans > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif'} alt="" /></span></li>}
																{(mk.question_type == 2) && <li>Correct Answer - <span>{mk.correct_answer}</span></li>}

																{mk.question_type == 4 && <span className=""><b>Your options are: </b></span>}
																{mk.question_option_answers.map((qas, i) => {
																	if (mk.question_type == 4) {
																		optionText.push(qas.options);
																	}
																	return this.getquestion(mk, qas, i + 1,data.imagezoom);
																})}

																{(mk.question_type == 6) && this.openendquestions(mk)}
																{(mk.question_type == 7) && this.matchfillfun(mk,data.imagezoom)}
															</ul>
															{mk.question_type == 8 && <div className="audiorecord">
																<audio key={`raudio_${index}`} controls controlsList="nodownload"><source src={domainUrl + "upload/recorded-voice/" + mk.answered} type="audio/mpeg" /></audio>
															</div>}

															{mk.question_type == 4 && <span className="integratestsmalltxt">
																Your Answer : {mk.answered} <img src={(mk.score > 0) ? process.env.PUBLIC_URL + '/images/tick.gif' : process.env.PUBLIC_URL + '/images/crossmark.gif'} alt="" border="0" /><br /> Correct Answer : {mk.correct_answer}
															</span>
															}
														</div>
														<div className="dottedline"></div>
														{ $.inArray(mk.question_type, [1,2,3,4,5,6,7,8]) >= 0 && data.is_performance && <div className="dottedline">
															<span className="bluetxt score">
																Your Score - <span className="greentxt"><strong>{(mk.is_YTA > 0 && mk.score < 1) ? <span className="greentxt">YTA<sup>*</sup></span> : mk.score}</strong>
																	{mk.is_hint_viewed > 0 && <strong>(You have viewed hint for this question)</strong>} </span>
															</span>
														</div> }
													</div>
													{mk.is_answer_explained == '1' &&
														<div className="ans-explanation">
															<h3>Answer Explanation</h3>

															{quscomd[mk.question_id].videoexpfile != '' && this.video_frameexp(quscomd[mk.question_id].videoexpfile, '')}

															{quscomd[mk.question_id].audiofile != '' &&
																<audio key='comd' controls controlsList="nodownload"><source src={rootDomainUrl + "admin/test_audio_files/" + quscomd[mk.question_id].audiofile} type="audio/mpeg" /></audio>
															}

															{quscomd[mk.question_id].imagefile != '' && <div className="ans-exp-img">
															{(data.imagezoom)?
															<Imagezoom  izsrc={rootDomainUrl + "/admin/test_image_files/" + quscomd[mk.question_id].imagefile} izalt="" izwidth="300" />
															:
															<img  src={rootDomainUrl + "/admin/test_image_files/" + quscomd[mk.question_id].imagefile} alt="" width="300" />	
															}
															</div>
															}
															{quscomd[mk.question_id].answer_comment != '' && <p dangerouslySetInnerHTML={{ __html: quscomd[mk.question_id].answer_comment }} />}
														</div>
													}
												</div>
												{this.state.testcont.confidence_meter==1 ? <Confidencemeter dynamic_confidence={mk.question_id} confidence_result={mk.confidence_result} correct_ans={mk.correct_answer} /> : ''}
											</div>
										</div>
									})}

									{ data.score_disable == false && data.score_comment != undefined && data.is_performance=='1' && <span className="testperformance">{data.score_comment}</span>}

									{(this.props.usableType == "webapp") ? <div className="button">
										<input type="submit" value="Continue" title="Continue" className="button_org" onClick={() => this.backToComponentList()} />
									</div> : ""}
								</div>
								}

								
							</div>
						</section>
					</section>
				</section>
			</div>
		</div>);
	}
}



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Testresults.js